import { render, staticRenderFns } from "./protocol_number_one.vue?vue&type=template&id=6a34c1bf&scoped=true"
import script from "./protocol_number_one.vue?vue&type=script&lang=js"
export * from "./protocol_number_one.vue?vue&type=script&lang=js"
import style0 from "./protocol_number_one.vue?vue&type=style&index=0&id=6a34c1bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a34c1bf",
  null
  
)

export default component.exports